import React from 'react';

function Brokerage() {
    return ( 
        <div className="container border-top">
            <div className="row mt-5">
                <div className="col-5 text-center">
                    <h4 style={{color:"#5C5CFF"}}>Brokerage Calculator</h4>
                    <br /><br />
                    <ul>
                        <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                         <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                         <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                         <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                         <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                         <li>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </li>
                        <br />
                    </ul>

                </div>
                <div className="col-4"></div>
                <div className="col-3">
                    <h4 style={{color:"#5C5CFF"}}>List of charges</h4>
                </div>
            </div>
        </div>
     );
}

export default Brokerage;